import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { Wrapper } from './Accessibility.elements';

export const ACCESSIBILITY_ID = 'accessibility';

export interface AccessibilityProps {}

const AccessibilityTemplate: FC<AccessibilityProps> = () => {
    return (
        <Wrapper>


<span className="title" id={`${ACCESSIBILITY_ID}-sekcia`}>
                Prístupnosť
            </span>

            <p className="section">
                E-shop <a href="https://profivzdelavanie.sk">profivzdelavanie.sk</a> je prevádzkovaný s&nbsp;dôrazom na&nbsp;prístupnosť pre&nbsp;všetkých používateľov. V&nbsp;súlade so&nbsp;zákonom č.&nbsp;351/2022 Z. z. o&nbsp;prístupnosti výrobkov a&nbsp;služieb informujeme, že niektoré naše služby, elektronické produkty a&nbsp;systémy vznikli pred&nbsp;účinnosťou predmetného zákona a&nbsp;využívajú zákonné <b>prechodné obdobie do&nbsp;28.&nbsp;6.&nbsp;2030</b>.
            </p>

            <p>
                Aktívne pracujeme na&nbsp;modernizácii a úprave digitálneho obsahu, aby sme zabezpečili jeho zrozumiteľnosť, ovládateľnosť a&nbsp;kompatibilitu s&nbsp;asistenčnými technológiami (čítačky obrazovky, ovládanie klávesnicou a&nbsp;pod.).
            </p>

            <p>
                Pokiaľ narazíte na&nbsp;obsah, ktorý nie je prístupný, alebo potrebujete pomoc so&nbsp;získaním informácií v prístupnej forme, prosím, kontaktujte nás.</p>

            <p>
                <b>Kontakt:</b>
            </p>

            <p className="section">
                E-mail: <a href="mailto:profivzdelavanie@pp.sk">profivzdelavanie@pp.sk</a><br />
                Tel.: <a href="tel:041/70 53 888">041/70 53 888</a><br />
                Adresa: Poradca podnikateľa, s. r. o., Martina Rázusa 23A, 010 01 Žilina
            </p>

    

        </Wrapper>
    );
};

export default AccessibilityTemplate;
